import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalRef } from '@anthem/uxd/modal';
import { IntentScenario } from '../../../../../common/enums/intent';
import { EventHandler } from '../../../../../common/services/eventHandler';
import { AppSession } from '../../../../../common/values/appSession';
import { SydneyChatbotEventChannelUtil } from '../../../../../fad/utilities/sydneyChatbotEventChannelUtil';
import { IProviderList } from '../../../../../findcare/result/interfaces/iProvider';
import { NAVIGATION_ALERT_IDS } from '../../../contents/common/alertTypeConfig';
import { FindCarePageType } from '../../../enums/findCarePages';
import { IAlertMessage } from '../../../interfaces/iPageAlert';
import { CommonUtility } from '../../../utilities/commonUtil';
import { BaseComponent } from '../../core/baseCmp';
import { SBHCSliderComponent } from '../common-slider-alert/components/sbhc-slider-message/sbhcSliderCmp';
import { GenericAlertNavigationService } from '../modal/services/genericAlertNavigationSvc';
import { PageAlertHandler } from './service/pageAlertHandler';

@Component({
  moduleId: module.id,
  selector: 'app-fc-page-alert-detail-cmp',
  templateUrl: './pageAlertDetailCmp.html'
})
export class pageAlertDetailComponent extends BaseComponent implements OnInit {
  detailsPageAlerts: IAlertMessage[] = null;
  resultPageAlerts: IAlertMessage[] = null;
  @Output()
  pageTitle: string = null;
  @Input() providersInfo: IProviderList;
  @Input() pageName: FindCarePageType;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('sbhcSliderCmp') sbhcSliderCmp: SBHCSliderComponent;
  sbhcSidePanelRef: ModalRef<HTMLElement>;

  constructor(
    private _route: ActivatedRoute,
    private _eventHandler: EventHandler,
    @Inject(AppSession)
    private _appSession: AppSession,
    private genericAlertNavigationService?: GenericAlertNavigationService
  ) {
    super(_route, _eventHandler, _appSession);
  }

  ngOnInit() {
    if (this.waitUntilAppReload) {
      return;
    }
    this.pageTitle = this.content?.common?.pageAlertComponentLabels?.notice;
    this.detailsPageAlerts = this._appSession.pageAlerts[this.pageName];
  }

  getMessage(alertMessage: IAlertMessage) {
    return PageAlertHandler.replaceLiteralwithContent(alertMessage.id, this.providersInfo, this._appSession, this.content);
  }

  getIconStyle(type: string): string {
    return PageAlertHandler.getIconStyle(type);
  }

  @HostListener('click', ['$event']) onSearchClick(event) {
    if (event?.target?.className === 'navigateToChatBtn') {
      this.closeModal.emit();
      SydneyChatbotEventChannelUtil.publishEventForIntent(IntentScenario.BH_NON_CRISIS, this._appSession.bhNonCrisisIntentQuery, this._appSession, this._eventHandler);
    }
    if (event?.target?.className.includes(NAVIGATION_ALERT_IDS.PA_NAVIGATE_PLAN_SELECTION)) {
      this.closeModal.emit();
      CommonUtility.clearSearchCriteria(this._appSession);
      this.genericAlertNavigationService.onClickOnPageAlert(NAVIGATION_ALERT_IDS.PA_NAVIGATE_PLAN_SELECTION);
    }
    if (event?.target?.className === 'fcr-sbhc-alert') {
      if (document.getElementsByClassName('overlay-container') && document.getElementsByClassName('overlay-container').length) {
        document.getElementsByClassName('overlay-container')[0].innerHTML = '';
      }
      this.sbhcSliderCmp.openSlider();
    }
  }
}
